import PropTypes from 'prop-types'
import { useState } from 'react'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Button, Collapse, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { useSelector } from 'react-redux'

import { selectSelectedFacets } from 'store/selectors/facets'

import FacetsNestedListItem from './FacetsNestedListItem'
import FacetsModal from './Modal'
import { hasSelection, facetSort } from './helpers'
import { useTranslation } from 'react-i18next'

const MAX_NUMBER_OF_ITEMS = 7

const FacetsListItem = ({ facetType, name, items }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  if (!items || !Array.isArray(items)) return <div />

  const [expanded, setExpanded] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const selectedFacets = useSelector(selectSelectedFacets)
  const itemsWithDocCount = items
    .filter(
      item => item.docCount || hasSelection(selectedFacets, item, facetType) || item.level === 0
    )
    .sort((a, b) => facetSort(a, b, facetType, selectedFacets))
  const firstSevenItems = itemsWithDocCount.slice(0, MAX_NUMBER_OF_ITEMS)
  const remainingItems = itemsWithDocCount.slice(MAX_NUMBER_OF_ITEMS)

  const onClick = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <ListItem className="category" disablePadding onClick={onClick}>
        <ListItemText>{name}</ListItemText>
        <ListItemIcon>
          <Button className="expand">{expanded ? <ExpandLess /> : <ExpandMore />}</Button>
        </ListItemIcon>
      </ListItem>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List>
          {firstSevenItems &&
            firstSevenItems.map(({ id, name, children, docCount }) => (
              <FacetsNestedListItem
                indentation={0}
                key={id}
                id={id}
                facetType={facetType}
                name={name}
                docCount={docCount != '0' ? docCount : (docCount = '')}
                items={children}
              />
            ))}
        </List>

        {items.length > MAX_NUMBER_OF_ITEMS && (
          <Button
            className="Search-page__facets-show-more-button"
            onClick={() => setShowModal(true)}
          >
            {t.facets.showMore.replace('{countResults}', remainingItems.length)}
          </Button>
        )}
      </Collapse>

      <hr />

      {showModal && (
        <FacetsModal
          showModal={showModal}
          facetType={facetType}
          modalTitle={name}
          items={remainingItems}
          onDismiss={() => setShowModal(false)}
        />
      )}
    </>
  )
}

FacetsListItem.propTypes = {
  facetType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  parents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      facetType: PropTypes.string.isRequired
    })
  )
}

FacetsListItem.defaultProps = {
  parents: []
}

export default FacetsListItem
